import { reducePracticesForGetClient } from "../pages/Connections/connections.middleware";
import { getPractices } from "./practices.util";

export const getSelectedClient = (selectedPractices = []) => {
  const practices = getPractices();
  const client = reducePracticesForGetClient(practices, selectedPractices[0]);

  return Object.entries(client).length > 0 ? client : null;
};
